/**
 * English Translations
 */

import type { DashboardTranslations } from './types'

export const enTranslations: DashboardTranslations = {
  overview: 'Overview',

  balance: {
    title: 'Available Balance',
    creditLimit: 'Credit Limit',
    available: 'Available',
    used: 'used',
    wallet: 'Wallet',
  },

  orders: {
    title: 'Total Orders',
    pending: 'pending',
    processing: 'processing',
    delivered: 'delivered',
    total: 'total',
  },

  deliveries: {
    title: 'Products Delivered',
    tons: 'tons',
    count: 'deliveries',
    accepted: 'accepted',
    pending: 'pending',
  },

  summary: {
    totalQuantity: 'Total Quantity',
    cities: 'Cities',
    customers: 'Customers',
    orders: 'Orders',
  },

  pending: {
    title: 'Pending Pickup',
    processing: 'processing',
    awaiting: 'awaiting pickup',
  },

  pendingDeliveries: {
    title: 'Pending Deliveries',
    accepted: 'accepted',
    awaiting: 'awaiting acceptance',
  },

  dateRange: {
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisQuarter: 'This Quarter',
    thisYear: 'This Year',
    last30Days: 'Last 30 Days',
    custom: 'Custom Range',
    from: 'From',
    to: 'To',
  },

  error: {
    loadFailed: 'Failed to load dashboard data. Please try again.',
    refreshFailed: 'Failed to refresh dashboard data.',
  },

  chart: {
    orderActivity: 'Order Activity',
    table: {
      period: 'Period',
      orders: 'Orders',
      tons: 'Tons',
      chartView: 'Chart',
      tableView: 'Table',
    },
    trend: 'Orders and deliveries trend',
    totalQuantityOverTime: 'Total Quantity Over Time',
    quantityTrend: 'Delivered tons trend over selected period',
    orders: 'Orders',
    tons: 'Tons Delivered',
  },

  rankings: {
    table: {
      avgLoading: 'Avg Loading',
      avgWait: 'Avg Wait',
      name: 'Name',
      product: 'Product',
      plant: 'Plant',
      total: 'Total',
      orders: 'Orders',
      share: 'Share',
      deliveries: 'Deliveries',
      barView: 'Bar Chart',
      tableView: 'Table',
    },
    title: 'Performance Rankings',
    subtitle: 'Top performing products, customers and delivery locations',
    topProducts: 'Top Products',
    topProductsByPackaging: 'Top Products by Packaging',
    topCustomers: 'Customer Distribution',
    topCities: 'Top Delivery Cities',
    deliveredTons: 'Delivered Tons',
    bulk: 'Bulk',
    bags: 'Bags',
    chartTypes: 'Chart',
    noData: 'No data for selected period',
    marketShare: 'Volume share by top customers',
    byTons: 'Volume breakdown by packaging type',
    deliveryLocations: 'Geographic distribution of deliveries',
    factoryPerformance: 'Plant Performance',
    factoryPerformanceDesc: 'Delivered volume per plant',
    clickForDetails: 'Click a plant for details',
    clickItemForDetails: 'Click an item for details',
  },

  factoryDrawer: {
    title: 'Plant Details',
    overview: 'Overview',
    topProducts: 'Top Products',
    topCustomers: 'Top Customers',
    topCities: 'Top Cities',
    totalTons: 'Total Tons',
    totalOrders: 'Orders',
    totalProducts: 'Products',
    totalDeliveries: 'Deliveries',
    bulk: 'Bulk',
    bags: 'Bags',
    noData: 'No data available',
    packagingBreakdown: 'Packaging Breakdown',
  },

  entityDrawer: {
    customerDetails: 'Customer Details',
    productDetails: 'Product Details',
    cityDetails: 'City Details',
    topPlants: 'Top Plants',
    topProducts: 'Top Products',
    topCustomers: 'Top Customers',
    topCities: 'Top Cities',
    overview: 'Overview',
    totalTons: 'Total Tons',
    totalOrders: 'Orders',
    totalProducts: 'Products',
    totalDeliveries: 'Deliveries',
    bulk: 'Bulk',
    bags: 'Bags',
    noData: 'No data available',
    packagingBreakdown: 'Packaging Breakdown',
  },

  liveFeed: {
    title: 'Live at Plant',
    subtitle: '{{count}} vehicles currently at plant',
    empty: 'No vehicles at plant right now',
    lastUpdated: 'Last updated: {{time}}',
    fields: {
      driver: 'Driver',
      factory: 'Plant',
      customer: 'Customer',
      loadingLocation: 'Loading Location',
      product: 'Product',
    },
    status: {
      arrived: 'Arrived',
      loading: 'Loading',
      weighing: 'Weighing',
      completed: 'Loaded',
    },
  },

  quickActions: {
    title: 'Quick Actions',
    newSalesOrder: 'New Sales Order',
    myOrders: 'My Orders',
  },

  ordersValue: {
    title: 'Orders Value (incl. VAT)',
    subtitle: 'Active orders total including 15% tax',
    beforeTax: 'Before Tax',
    tax: 'VAT 15%',
    activeOrders: 'active orders',
  },

  customerBalance: {
    title: 'Customer Balance',
    subtitle: 'Available balance on your account',
  },

  balanceDiff: {
    title: 'Balance vs Orders',
    surplus: 'Surplus',
    deficit: 'Deficit',
  },

  units: {
    bulk: 'Bulk',
    bags: 'Bags',
  },

  currency: {
    sar: 'SAR',
    usd: 'USD',
  },
}
